/**
 * Vite dev does not register a service worker, but a stale SW from a prior
 * production/preview build on the same origin (e.g. localhost:5173) intercepts
 * fetches and spams "Failed to fetch" from workbox's networkWithCacheFallback.
 */
export async function unregisterServiceWorkersInDev(): Promise<void> {
  if (!import.meta.env.DEV || !("serviceWorker" in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  if (registrations.length === 0) {
    return;
  }

  await Promise.all(registrations.map((r) => r.unregister()));

  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  }
}
